import styled from 'styled-components';

export const StyledStatsChartWrapper = styled.main`
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const StyledIntegrationStatsChart = styled.div`
  margin: 0 1rem;
  width: 10rem;
  height: 3rem;
`;
